/**
 * productBillingInfoModule 租户-产品计费信息
 * Author Qian.qianchen 2019-07-05
 */
'use strict';
angular.module("productBillingInfoModule", [])
    .controller("productBillingInfoCtrl", ["$scope", "trsspliceString", "$q", "$filter", "modalDialog", "trsHttpService", "loginService",
        function($scope, trsspliceString, $q, $filter, modalDialog, trsHttpService, loginService) {
            initStatus();
            initData();
            /**
             * [initStatus description] 状态初始化
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    statusList: [{ name: '全部状态', value: 0 }, { name: '已开通', value: 1 }, { name: '未开通', value: -1 }],
                    childTableShowFlag: true,
                }
                $scope.data = {
                    keywords: '',
                    selectedStatus: [],
                    items: [],
                }
            }

            /**
             * [initData description] 数据初始化
             * @return {[type]} [description]
             */
            function initData() {
                $scope.data.selectedStatus = $scope.status.statusList[0];
                getCurrLoginUser()
            }
            /**
             * [getCurrLoginUser ]获取用户信息
             */
            function getCurrLoginUser() {
                loginService.getCurrLoginUser().then(function(data) {
                    $scope.status.userData = data;
                    getData()
                });
            }
            /**
             * [requestData description] 数据请求
             * @param  {[type]} ev [description]
             * @return {[type]}    [description]
             */
            $scope.requestData = function(ev) {
                    if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                        getData()
                    }
                }
                /** 
                 * [getData description] 请求数据
                 */
            function getData() {
                let deffer = $q.defer();
                let params = {
                    "serviceid": "mlf_billing",
                    "methodName": "queryBillingModulesByTenant",
                    "TenantId": $scope.status.userData.TENANTID,
                    "Status": $scope.data.selectedStatus.value,
                };
                if ($scope.data.keywords) {
                    params.ModuleName = $scope.data.keywords;
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "GET").then(function(result) {
                    $scope.data.items = result == '' ? [] : result;
                    deffer.resolve();
                });
                return deffer.promise;
            }
        }
    ])
    .filter('myTimeFormat', function() {
        return function(str) {
            if (str && str.length == 39) {
                str = str.replace(/-/g, '/');
                var d = str.substring(0, 10);
                var t = str.substring(20, 30);
                return d + '-' + t;
            } else {
                return str
            }
        }
    });